document.addEventListener('DOMContentLoaded', function() {
  function getCookie(name) {
    let matches = document.cookie.match(new RegExp(
      "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }

  function setCookie(name, value, options = {}) {
    options = {
      path: '/',
      ...options
    };

    if (options.expires instanceof Date) {
      options.expires = options.expires.toUTCString();
    }

    let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

    for (let optionKey in options) {
      updatedCookie += "; " + optionKey;
      let optionValue = options[optionKey];
      if (optionValue !== true) {
        updatedCookie += "=" + optionValue;
      }
    }

    document.cookie = updatedCookie;
  }

  let availableQuantity = getCookie('availableQuantity');
  if (!availableQuantity) {
    availableQuantity = Math.floor(Math.random() * (19 - 6 + 1)) + 6; // Número aleatorio entre 6 y 21
    setCookie('availableQuantity', availableQuantity);
  }

  var maxQuantity = 75; // Basado en 90 en lugar de 100
  var progressPercentage = (availableQuantity / maxQuantity) * 100;

  var progressBar = document.querySelector('.progress');
  if (progressBar) {
    progressBar.style.width = progressPercentage + '%';
  }

  var progressNumber = document.querySelector('.progress-number');
  if (progressNumber) {
    progressNumber.innerText = availableQuantity;
  }
});